/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, monthlyEquivalent: NonNullable<unknown> }} Signup_Price_Yearly_DisplayInputs */

const en_signup_price_yearly_display = /** @type {(inputs: Signup_Price_Yearly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/year ($${i?.monthlyEquivalent}/mo)`)
};

const fr_signup_price_yearly_display = /** @type {(inputs: Signup_Price_Yearly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/an ($${i?.monthlyEquivalent}/mois)`)
};

const de_signup_price_yearly_display = /** @type {(inputs: Signup_Price_Yearly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/Jahr ($${i?.monthlyEquivalent}/Monat)`)
};

const it_signup_price_yearly_display = /** @type {(inputs: Signup_Price_Yearly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/anno ($${i?.monthlyEquivalent}/mese)`)
};

const ru_signup_price_yearly_display = /** @type {(inputs: Signup_Price_Yearly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/год ($${i?.monthlyEquivalent}/мес)`)
};

const es_signup_price_yearly_display = /** @type {(inputs: Signup_Price_Yearly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/año ($${i?.monthlyEquivalent}/mes)`)
};

const zh_cn2_signup_price_yearly_display = /** @type {(inputs: Signup_Price_Yearly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/年（$${i?.monthlyEquivalent}/月）`)
};

const ja_signup_price_yearly_display = /** @type {(inputs: Signup_Price_Yearly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`年間$${i?.amount} (月額$${i?.monthlyEquivalent})`)
};

const hi_signup_price_yearly_display = /** @type {(inputs: Signup_Price_Yearly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/वर्ष ($${i?.monthlyEquivalent}/माह)`)
};

const pt_pt2_signup_price_yearly_display = /** @type {(inputs: Signup_Price_Yearly_DisplayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`$${i?.amount}/ano ($${i?.monthlyEquivalent}/mês)`)
};

/**
* | output |
* | --- |
* | "${amount}/year (${monthlyEquivalent}/mo)" |
*
* @param {Signup_Price_Yearly_DisplayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_price_yearly_display = /** @type {((inputs: Signup_Price_Yearly_DisplayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Price_Yearly_DisplayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_price_yearly_display(inputs)
	if (locale === "de") return de_signup_price_yearly_display(inputs)
	if (locale === "it") return it_signup_price_yearly_display(inputs)
	if (locale === "ru") return ru_signup_price_yearly_display(inputs)
	if (locale === "es") return es_signup_price_yearly_display(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_price_yearly_display(inputs)
	if (locale === "ja") return ja_signup_price_yearly_display(inputs)
	if (locale === "hi") return hi_signup_price_yearly_display(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_price_yearly_display(inputs)
	return en_signup_price_yearly_display(inputs)
});